import { NotifyHelper } from "../../../helpers/toast";
import { eTieuDeBaoCaoActionsObj } from "../../action-types/category/ITieuDeBaoCaoActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tieuDeBaoCaoActions = {
    ...generateActions(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO"),
    ...generateActionForKey(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO", "SAVE_SUCCESS", () => {  NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
     ...generateActionForKey(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
}